// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3ciZV","head":"ProcedureTableInfo_head__vkxuT"};